<template>
    <div style="padding: 10px">
        <Modal v-model="isShowStateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>修改账号信息</span>
            </p>
            <Form :model="updateObject" label-position="left" :label-width="100">
                <FormItem label="客户账号">
                    <Input v-model="updateObject.userAccount" placeholder="输客户账号" style="width: 250px" />
                </FormItem>
                <FormItem label="客户名称">
                    <Input v-model="updateObject.userName" placeholder="输入客户名称" style="width: 250px" />
                </FormItem>
                <!-- <FormItem label="用户身份">
          <Select v-model="updateObject.userAuth" style="width:250px" placeholder="选择表具类型">
            <Option v-for="(value, key) in userAuthEnum" :value="key" :key="key">{{value}}</Option>
          </Select>
        </FormItem> -->
                <FormItem label="设备类型">
                    <Select v-model="updateObject.userMeterType" style="width:250px" placeholder="选择表具类型">
                        <Option v-for="(value, key) in userMeterTypeEnum" :value="key" :key="key">{{ value }}</Option>
                        <!-- <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{item}}</Option> -->
                    </Select>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button style="margin-left:10px" type="primary" icon="ios-search" @click="updateUser">提交更新</Button>
            </div>
        </Modal>
        <Modal v-model="isShowMeterStateModal" :mask-closable="false" width="380">
            <p slot="header" style="color:#19be6b;text-align:center">
                <Icon type="md-create" />
                <span>修改设备信息</span>
            </p>
            <Form :model="updateMeterObject" label-position="left" :label-width="100">
                <FormItem v-show="false" label="出厂日期">
                    <DatePicker v-model="updateMeterObject.出厂日期" @on-change="handleChange" type="date" placeholder="选择出厂日期" style="width: 250px"></DatePicker>
                </FormItem>
                <FormItem style="margin-top:-20px" label="表具类型">
                <Select v-model="updateMeterObject.meterType" style="width:250px" placeholder="选择表具类型">
                    <!-- <Option value="水表" key="水表">水表</Option> -->
                    <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{item}}</Option>
                </Select>
                </FormItem>
                <FormItem style="margin-top:-20px" label="表具地址" placeholder="输入表具地址">
                    <Input v-model="updateMeterObject.meterAddress" placeholder="输入表具地址" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="口径" placeholder="输入口径">
                    <Input v-model="updateMeterObject.meterCaliber" placeholder="输入口径" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="初始正流量" placeholder="初始正流量">
                    <Input v-model="updateMeterObject.meterFlowForward" placeholder="输入初始正流量" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="初始反流量" placeholder="初始反流量">
                    <Input v-model="updateMeterObject.meterFlowBackward" placeholder="输入初始反流量" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="运营商" placeholder="运营商">
                    <Input v-model="updateMeterObject.meterOperator" placeholder="输入运营商" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="NB模块IMEI" placeholder="NB模块IMEI">
                    <Input v-model="updateMeterObject.meterImei" placeholder="输入NB模块IMEI" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="NB卡IMSI" placeholder="NB卡IMSI">
                    <Input v-model="updateMeterObject.meterImsi" placeholder="输入NB卡IMSI" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="NB卡ICCID" placeholder="NB卡ICCID">
                    <Input v-model="updateMeterObject.meterIccid" placeholder="输入NB卡ICCID" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="域名(IP)及端口" placeholder="域名(IP)及端口">
                    <Input v-model="updateMeterObject.meterIpport" placeholder="输入域名(IP)及端口" style="width: 250px" />
                </FormItem>
                <!-- <FormItem style="margin-top:-20px" label="采集模式" placeholder="采集模式">
                    <Input v-model="updateMeterObject.meterCatchMode" placeholder="输入采集模式" style="width: 250px" />
                </FormItem> -->
                <FormItem style="margin-top:-20px" label="采集模式">
                    <Select v-model="updateMeterObject.meterCatchMode" style="width:250px" placeholder="选择采集模式">
                        <Option value="周期采集" key="周期采集">周期采集</Option>
                        <Option value="定时采集" key="定时采集">定时采集</Option>
                    </Select>
                </FormItem>
                <FormItem style="margin-top:-20px" label="采集间隔(分钟)" placeholder="采集间隔(分钟)">
                    <Input v-model="updateMeterObject.meterCatchInterval" placeholder="输入采集间隔(分钟)" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="定时采集时间1" placeholder="定时采集时间1">
                    <Input v-model="updateMeterObject.meterCatchInterval1" placeholder="输入定时采集时间1" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="定时采集时间2" placeholder="定时采集时间2">
                    <Input v-model="updateMeterObject.meterCatchInterval2" placeholder="输入定时采集时间2" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="定时采集时间3" placeholder="定时采集时间3">
                    <Input v-model="updateMeterObject.meterCatchInterval3" placeholder="输入定时采集时间3" style="width: 250px" />
                </FormItem>
                <FormItem style="margin-top:-20px" label="定时采集时间4" placeholder="定时采集时间4">
                    <Input v-model="updateMeterObject.meterCatchInterval4" placeholder="输入定时采集时间4" style="width: 250px" />
                </FormItem>
                <!-- <FormItem style="margin-top:-20px" label="表端协议类型" placeholder="表端协议类型">
                    <Input v-model="updateMeterObject.meterProtocolType" placeholder="输入表端协议类型" style="width: 250px" />
                </FormItem> -->
                <FormItem style="margin-top:-20px" label="表端协议类型">
                    <Select v-model="updateMeterObject.meterProtocolType" style="width:250px" placeholder="选择表端协议类型">
                        <!-- <Option v-if="selectMeterType == 0" value="水表协议 – JP" key="水表协议 – JP">水表协议 – JP</Option>
                        <Option v-if="selectMeterType == 0" value="水表协议 – ZP" key="水表协议 – ZP">水表协议 – ZP</Option>
                        <Option v-if="selectMeterType == 1" value="热表协议 – JP" key="热表协议 – JP">热表协议 – JP</Option>
                        <Option v-if="selectMeterType == 1" value="热表协议 – QY" key="热表协议 – QY">热表协议 – QY</Option>
                        <Option v-if="selectMeterType == 2" value="流量计协议 – JP" key="流量计协议 – JP">流量计协议 – JP</Option> -->
                        <Option v-for="item in protocolEnum" :value="item" :key="item">{{ item }}</Option>
                    </Select>
                </FormItem>
                <FormItem style="margin-top:-20px" label="电池电压" placeholder="电池电压">
                    <Input v-model="updateMeterObject.meterVoltage" placeholder="输入电池电压" style="width: 250px" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button style="margin-left:10px" type="primary" icon="ios-search" @click="commitUpdate">提交更新</Button>
            </div>
        </Modal>
        <Modal v-model="isShowSetModal" :mask-closable="false" width="700">
            <p slot="header" style="text-align:center">
                <Icon type="md-create" />
                <span>显示项设置</span>
            </p>
            <!-- <tr v-for="(value, key) in stateArray" :value="value" :key="key">
          <td style="width:190px">{{key + ":"}}</td>
          <td>{{value}}</td>
        </tr> -->
            <Form label-position="left" :label-width="100" style="margin-left:20px">
                <FormItem label="展示数据">
                    <Tag
                        :checked="showColumnTitleArray.indexOf(item.title) > -1"
                        v-for="item in columnsbackup"
                        :name="item.title"
                        @on-change="changeColumn"
                        size="medium"
                        checkable
                        color="primary"
                        >{{ item.title }}</Tag
                    >
                </FormItem>
            </Form>
            <div slot="footer">
                <!-- <Button type="primary" @click="true" style="margin-left: 20px;">确定</Button> -->
            </div>
        </Modal>
        <div style="background: #fff; border-radius: 8px; padding: 20px;">
            <div class="query-c">
                <Row style="white-space:nowrap;">
                    <Col span="24" style="padding:2px;margin:2px;border-radius: 25px;">
                        <Select
                            clearable
                            v-model="searchObject.meterType"
                            style="width:8%;margin-right: 5px"
                            placeholder="选择表具类型"
                        >
                            <!-- <Option value="水表" key="水表">水表</Option> -->
                            <Option v-for="item in meterTypeEnum" :value="item" :key="item">{{ item }}</Option>
                        </Select>
                        <!-- <Input v-model="searchObject.userAccount" placeholder="输入用户账号(模糊查询)" style="width: 200px;margin-right: 5px" /> -->
                        <Select
                            clearable
                            filterable
                            v-model="searchObject.userAccount"
                            style="width:20%;margin-right: 5px"
                            placeholder="选择客户"
                        >
                            <Option v-for="item in userList" v-if="getMeterType(item.userMeterType).indexOf(searchObject.meterType) > -1 " :value="item.userAccount" :key="item.userAccount">{{
                                item.userName
                            }}</Option>
                        </Select>
                        <Select
                            clearable
                            filterable
                            placeholder="选择表具口径"
                            v-model="searchObject.meterCaliber"
                            style="width:10%;"
                        >
                            <Option v-for="item in caliberEnum" :value="item" :key="item">{{ item }}</Option>
                        </Select>
                        <Input v-model="searchObject.meterAddress" placeholder="输入表具地址" style="width: 16%;margin-left: 5px" />
                    
                        <DatePicker
                            v-show="false"
                            :options="optionsDisabled"
                            v-model="searchObject.startDate"
                            type="date"
                            placeholder="出厂日期"
                            style="width: 12%;margin-left:5px"
                        ></DatePicker>
                        <!-- <DatePicker
                            v-model="searchObject.endDate"
                            type="date"
                            placeholder="结束日期"
                            style="width: 12%;margin-left:5px"
                        ></DatePicker> -->
                        <Button style="margin-left:5px;float:right" type="primary" @click="isShowSetModal = true" >显示项设置</Button>
                        <Button style="margin-left:5px;float:right;width: 6%;" type="primary" icon="ios-search" @click="showPage">查询</Button>
                    </Col>
                </Row>
                <Row style="white-space:nowrap;">
                    <Col span="24" style="padding:2px;margin:2px;border-radius: 25px;">
                        <Upload
                            ref="upload"
                            name="file"
                            style="display: none;"
                            :action="action"
                            :on-success="handelResponse"
                            :format="['xlsx', 'xls']"
                            :show-upload-list="false"
                        >
                            <input id="upload_file_factory" />
                        </Upload>
                        <Button type="primary" style="margin-left:5px;float:right" size="primary" @click="exportData()"
                            ><Icon type="ios-download-outline;"></Icon>数据导出</Button
                        >
                        <Button type="primary" @click="showImport = true" style="margin-left:5px;float:right">数据导入</Button>
                        <Button type="primary" @click="showDownload = true" style="margin-left:5px;float:right">模板下载</Button>
                    </Col>
                </Row>
            </div>
            <Table ref="table" size="small" :height="tableHeight" border stripe :columns="columns" :data="data" highlight-row>
                <template slot-scope="{ row, index }" slot="action">
                    <Button type="primary" size="small" style="margin-right: 5px" @click="updateMeter(row)">修改</Button>
                    <Button type="primary" size="small" style="margin-right: 5px" @click="delMeter(row)">删除</Button>
                </template>

                <template slot-scope="{ row, index }" slot="wxstate">
                    <span v-if="row.userRemark1 != undefined && row.userRemark1 != ''" style="color:#19be6b">已绑定</span>
                    <span v-if="row.userRemark1 == undefined || row.userRemark1 == ''" style="color:#ed4014">未绑定</span>
                </template>
            </Table>
            <br />
            <!-- <Page :total="100" show-sizer show-elevator /> -->
        </div>
        <Modal title="模板下载" v-model="showDownload" footer-hide>
            <Button type="primary" @click="downloadTemplete">下载水表流量表出厂模板</Button>
            <Button type="primary" style="margin-left: 10px;" @click="downloadTempleteHot">下载热量表出厂模板</Button>
        </Modal>
        <Modal title="数据导入" v-model="showImport" footer-hide>
            <Button type="primary" @click="clickImport">导入水表流量表出厂模板</Button>
            <Button type="primary" style="margin-left: 10px;" @click="clickImportHot">导入热量表出厂模板</Button>
        </Modal>
    </div>
</template>

<script>
export default {
    name: "factoryversion",
    data() {
        var that = this;
        return {
            dateArray: [],
            optionsDisabled: {
                disabledDate (date) {
                    return date && that.dateArray.indexOf(global.dateFtt("yyyy-MM-dd", date)) == -1;
                }
            },
            action: "",
            showDownload: false,
            showImport: false,
            pageName: "factoryversion",
            meterTypeEnum: global.meterType(),
            searchObject: {
                meterType: "水表"
            },
            protocolEnum: [],
            updateObject: {},
            updateMeterObject: {},
            insertObject: {},
            showColumnTitleArray: [],
            isInserteModal: false,
            isShowMeterStateModal: false,
            isShowStateModal: false,
            userAccount: "",
            userName: "",
            columnsbackup: [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 160,
                    resizable: true
                },
                // {
                //     title: "出厂日期",
                //     width: 160,
                //     resizable: true,
                //     key: "出厂日期"
                // },
                {
                    title: "表具类型",
                    resizable: true,
                    width: 100,
                    key: "meterType"
                },
                {
                    title: "口径",
                    resizable: true,
                    width: 100,
                    key: "meterCaliber"
                },
                {
                    title: "表具地址",
                    resizable: true,
                    width: 150,
                    key: "meterAddress"
                },
                {
                    title: "初始正向流量",
                    resizable: true,
                    width: 120,
                    key: "初始正向流量"
                },
                {
                    title: "初始反向流量",
                    resizable: true,
                    width: 120,
                    key: "初始反向流量"
                },
                {
                    title: "运营商",
                    resizable: true,
                    width: 100,
                    key: "meterOperator"
                },
                {
                    title: "NB模块IMEI",
                    resizable: true,
                    width: 150,
                    key: "NB模块IMEI"
                },
                {
                    title: "NB卡IMSI",
                    resizable: true,
                    width: 150,
                    key: "NB卡IMSI"
                },
                {
                    title: "NB卡ICCID",
                    resizable: true,
                    width: 180,
                    key: "NB卡ICCID"
                },
                {
                    title: "域名(IP)及端口",
                    resizable: true,
                    width: 170,
                    key: "meterIpport"
                },
                {
                    title: "采集模式",
                    resizable: true,
                    width: 120,
                    key: "meterCatchMode"
                },
                {
                    title: "采集间隔(分钟)",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval"
                },
                {
                    title: "定时采集时间1",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval1"
                },
                {
                    title: "定时采集时间2",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval2"
                },
                {
                    title: "定时采集时间3",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval3"
                },
                {
                    title: "定时采集时间4",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval4"
                },
                {
                    title: "表端协议类型",
                    resizable: true,
                    width: 120,
                    key: "meterProtocolType"
                },
                {
                    title: "电池电压",
                    resizable: true,
                    width: 120,
                    key: "meterVoltage"
                },
                {
                    title: "操作",
                    slot: "action",
                    width: 150,
                    align: "center"
                }
            ],
            tableHeight: "200",
            addressfield1: "",
            addressfield2: "",
            addressfield3: "",
            addressfield4: "",
            addressfield5: "",
            // meterArray: ["00000018003155", "00000018004345", "00000018004361", "00000018004457", "00000018004523",
            //   "00000018004635", "00000018004782", "00000018004789", "00000018004798", "00000018004799", "00000018004850",
            //   "00000018005048", "00000018005051", "00000018005064", "00000018005332", "00000018005388", "00000018005401",
            //   "00000018005405", "00000018005456", "00000018005462"
            // ],
            meterArray: [],
            meterArray1: [
                "00000018003155",
                "00000018004361",
                "00000018004457",
                "00000018004523",
                "00000018004798",
                "00000018005064",
                "00000018005332",
                "00000018005401",
                "00000018005456",
                "00000018005462",
                "11110000000000"
            ],
            meterArray2: ["00000018005405", "00000018004345", "00000018004799"],
            addressObject: {},
            stateContrast: global.stateContrast,
            meterAddress: "",
            stateArray: {},
            userAuthEnum: {
                "0": "管理员",
                "1": "客户"
            },
            userMeterTypeEnum: {
                "0": "水表、流量计",
                "1": "热量表",
                "2": "动态平衡阀",
                "3": "消防栓",
                "4": "压力开关、流量开关"
            },
            isShowStateModal: false,
            isShowSetModal: false,
            columns: [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 160,
                    resizable: true
                },
                // {
                //     title: "出厂日期",
                //     width: 160,
                //     resizable: true,
                //     key: "出厂日期"
                // },
                {
                    title: "表具类型",
                    resizable: true,
                    width: 100,
                    key: "meterType"
                },
                {
                    title: "口径",
                    resizable: true,
                    width: 100,
                    key: "meterCaliber"
                },
                {
                    title: "表具地址",
                    resizable: true,
                    width: 150,
                    key: "meterAddress"
                },
                {
                    title: "初始正向流量",
                    resizable: true,
                    width: 120,
                    key: "初始正向流量"
                },
                {
                    title: "初始反向流量",
                    resizable: true,
                    width: 120,
                    key: "初始反向流量"
                },
                {
                    title: "运营商",
                    resizable: true,
                    width: 100,
                    key: "meterOperator"
                },
                {
                    title: "NB模块IMEI",
                    resizable: true,
                    width: 150,
                    key: "NB模块IMEI"
                },
                {
                    title: "NB卡IMSI",
                    resizable: true,
                    width: 150,
                    key: "NB卡IMSI"
                },
                {
                    title: "NB卡ICCID",
                    resizable: true,
                    width: 180,
                    key: "NB卡ICCID"
                },
                {
                    title: "域名(IP)及端口",
                    resizable: true,
                    width: 170,
                    key: "meterIpport"
                },
                {
                    title: "采集模式",
                    resizable: true,
                    width: 120,
                    key: "meterCatchMode"
                },
                {
                    title: "采集间隔(分钟)",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval"
                },
                {
                    title: "定时采集时间1",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval1"
                },
                {
                    title: "定时采集时间2",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval2"
                },
                {
                    title: "定时采集时间3",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval3"
                },
                {
                    title: "定时采集时间4",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval4"
                },
                {
                    title: "表端协议类型",
                    resizable: true,
                    width: 120,
                    key: "meterProtocolType"
                },
                {
                    title: "电池电压",
                    resizable: true,
                    width: 120,
                    key: "meterVoltage"
                },
                {
                    title: "操作",
                    slot: "action",
                    width: 150,
                    align: "center"
                }
            ],
            data: [],
            caliberEnum: [],
            userList: []
        };
    },
    methods: {
        handleChange (date) {
            this.updateMeterObject.meterBirth = new Date(date).getTime();
        },
        commitUpdate(){
            var that = this;
            that.$axios.post('/api/meter/updateMeter', that.updateMeterObject).then((data) => {
            if (data.errorCode != 0) {
                that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
                });
                return;
            }

            that.$Modal.success({
                title: "提示",
                content: "修改成功"
            });

            that.showPage();
            that.isShowStateModal = false
            }).catch((error) => {
            that.$Notice.error({
                title: "异常",
                desc: error
            });
            console.log(error);
            }).finally(() => {});
        },
        getMeterProtocolEnum(){
            var that = this;
            that.$axios.post('/api/meter/getMeterProtocolEnum', {}).then((data) => {
            if (data.errorCode != 0) {
                that.$Notice.error({
                title: "异常",
                desc: data.errorInfo
                });
                return;
            }
            
            that.protocolEnum = data.body;
            }).catch((error) => {
            that.$Notice.error({
                title: "异常",
                desc: error
            });
            console.log(error);
            }).finally(() => {
            // that.showPage();
            });
        },
        getMeterType(type){
            return global.getMeterType(type);
        },
        getUserList() {
            var that = this;
            that.$axios
                .post("/api/user/getUserList", {})
                .then(function(res) {
                    console.log(res);
                    that.userList = res.body;
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        getMeterCaliberEnum() {
            var that = this;
            that.$axios
                .post("/api/meter/getMeterCaliberEnum", {})
                .then(data => {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }

                    that.caliberEnum = data.body;
                    that.caliberEnum.sort(function(a,b){
                      return parseInt(a.replace("DN", "")) - parseInt(b.replace("DN", ""));
                    });
                })
                .catch(error => {
                    that.$Notice.error({
                        title: "异常",
                        desc: error
                    });
                    console.log(error);
                })
                .finally(() => {
                    // that.showPage();
                });
        },
        updateMeter(row) {
            this.updateMeterObject= row;
            this.isShowMeterStateModal = true;
        },
        delMeter(row) {
            var that = this;
            this.$Modal.confirm({
                title: "提示",
                content: "<p>是否要删除该设备？</p>",
                onOk: () => {
                    row.delType = 1;
                    that.$axios
                        .post("/api/meter/delMeter", row)
                        .then(data => {
                            if (data.errorCode != 0) {
                                that.$Notice.error({
                                    title: "异常",
                                    desc: data.errorInfo
                                });
                                return;
                            }

                            that.$Notice.success({
                                title: "提示",
                                desc: "删除成功"
                            });
                            return;
                        })
                        .catch(error => {
                            that.$Notice.error({
                                title: "异常",
                                desc: error
                            });
                            console.log(error);
                        })
                        .finally(() => {
                            that.showPage();
                        });
                },
                onCancel: () => {}
            });
        },
        clickImport() {
            this.action = "/api/excel/importMeterNew";
            $("#upload_file_factory").click();
            this.showImport = false;
        },
        clickImportHot() {
            this.action = "/api/excel/importMeterHOTNew";
            $("#upload_file_factory").click();
            this.showImport = false;
        },
        handelResponse(response, file, fileList) {
            console.log(response);
            console.log(file);
            console.log(fileList);
            if (response.errorCode != 0) {
                this.$Notice.error({
                    title: "导入失败",
                    desc: response.errorInfo,
                    duration: 0
                });
            } else {
                let result = response.body.exsitList;
                let insert = response.body.insertList;
                let count = " 共计导入" + insert.length + "条数据。";
                let indexs = "";
                if (result.length > 0) {
                    result.map(item => {
                        indexs = indexs == "" ? item.meterAddress : indexs + "," + item.meterAddress;
                    });
                }
                let msg = indexs == "" ? "" : " 表具地址为" + indexs + "数据重复,不予导入。";
                this.$Notice.success({
                    title: "成功",
                    desc: "导入成功！" + msg + count,
                    duration: 0
                });
                this.generateColumnTitleArray();
                this.getMeterCaliberEnum();
                this.showPage();
            }
        },
        exportData() {
            this.$refs.table.exportCsv({
                filename: "出厂信息"
            });
        },
        downloadTempleteHot() {
            window.location.href = "/api/excel/downloadLocal?fileUrl=" + "热量表出厂模板.xls";
            this.showDownload = false;
        },
        downloadTemplete() {
            window.location.href = "/api/excel/downloadLocal?fileUrl=" + "水表流量表出厂模板.xls";
            this.showDownload = false;
            // try {
            //   var json2csv = require('json2csv');
            //   let fileName = "表具出厂模板";
            //   const result = json2csv.parse([], {
            //     fields: ["序号","出厂日期","表具类型","表具地址","口径","初始正向流量（L）","初始反向流量（L）","运营商","IMEI","IMSI","ICCID","IP与端口号","采集模式","采集间隔（分钟）","定时采集时间1","定时采集时间2","定时采集时3","定时采集时间4","表端协议类型","电池电压（V）","用户账号"],
            //     excelStrings: true
            //   });
            //   if (this.MyBrowserIsIE()) {
            //     // IE10以及Edge浏览器
            //     var BOM = "\uFEFF";
            //             // 文件转Blob格式
            //     var csvData = new Blob([BOM + result], { type: "text/csv" });
            //     navigator.msSaveBlob(csvData, `${fileName}.csv`);
            //   } else {
            //     let csvContent = "data:text/csv;charset=utf-8,\uFEFF" + result;
            //     // 非ie 浏览器
            //     this.createDownLoadClick(csvContent, `${fileName}.csv`);
            //   }
            // } catch (err) {
            //   alert(err);
            // }
        },
        //创建a标签下载
        createDownLoadClick(content, fileName) {
            const link = document.createElement("a");
            link.href = encodeURI(content);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }, // 判断是否IE浏览器
        MyBrowserIsIE() {
            let isIE = false;
            if (navigator.userAgent.indexOf("compatible") > -1 && navigator.userAgent.indexOf("MSIE") > -1) {
                // ie浏览器
                isIE = true;
            }
            if (navigator.userAgent.indexOf("Trident") > -1) {
                // edge 浏览器
                isIE = true;
            }
            return isIE;
        },
        updateUser() {
            var that = this;
            that.isShowStateModal = false;
            that.$axios
                .post("/api/user/updateUser", that.updateObject)
                .then(data => {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }

                    that.$Notice.success({
                        title: "提示",
                        desc: "修改成功"
                    });
                    return;
                })
                .catch(error => {
                    that.$Notice.error({
                        title: "异常",
                        desc: error
                    });
                    console.log(error);
                })
                .finally(() => {
                    that.showPage();
                });
        },
        generateColumnTitleArray() {
            let titleArray = [];

            for (let i = 0; i < this.columnsbackup.length; i++) {
                titleArray.push(this.columnsbackup[i].title);
            }

            this.showColumnTitleArray = titleArray;

            if (localStorage.getItem(this.pageName + localStorage.getItem("userAccount") + this.searchObject.meterType) != undefined) {
                this.showColumnTitleArray = JSON.parse(
                    localStorage.getItem(this.pageName + localStorage.getItem("userAccount") + this.searchObject.meterType)
                );
                var showArray = [];
                for (let i = 0; i < this.columnsbackup.length; i++) {
                    let currentObject = this.columnsbackup[i];
                    if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
                        showArray.push(currentObject);
                    }
                }

                this.columns = showArray;
            }
        },
        getAddressEnum() {
            var that = this;
            that.$axios
                .post("/api/dictionary/selectAddressEnum", {})
                .then(data => {
                    if (data.errorCode != 0) {
                        that.$Notice.error({
                            title: "异常",
                            desc: data.errorInfo
                        });
                        return;
                    }

                    that.addressObject = data.body;
                })
                .catch(error => {
                    that.$Notice.error({
                        title: "异常",
                        desc: error
                    });
                    console.log(error);
                })
                .finally(() => {});
        },
        parseDate(str) {
            var year = str.substr(0, 4);
            var month = str.substr(4, 2);
            var day = str.substr(6, 2);
            var hour = str.substr(8, 2);
            var minute = str.substr(10, 2);
            var second = str.substr(12, 2);
            return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
        },
        onClickSearch() {
            this.showPage();
        },
        showState(row) {
            this.isShowStateModal = true;
            this.stateArray = JSON.parse(row.messageContent).decode.state;
        },
        showStateStr(row) {
            let stateArray = JSON.parse(row.messageContent).decode.state;
            let that = this;
            let stateStr = "";
            Object.keys(stateArray).forEach(function(key) {
                if (stateArray[key] == that.stateContrast[key]) {
                    stateStr = stateStr + key + " " + that.stateContrast[key] + "; ";
                }
            });

            return stateStr == "" ? "正常" : stateStr.replace("空管 空管", "空管");
        },
        changeColumn(checked, name) {
            if (checked) {
                this.showColumnTitleArray.push(name);
            } else {
                this.showColumnTitleArray.splice(this.showColumnTitleArray.indexOf(name), 1);
            }

            var showArray = [];

            for (let i = 0; i < this.columnsbackup.length; i++) {
                let currentObject = this.columnsbackup[i];
                if (this.showColumnTitleArray.indexOf(currentObject.title) > -1) {
                    showArray.push(currentObject);
                }
            }

            localStorage.setItem(
                this.pageName + localStorage.getItem("userAccount") + this.searchObject.meterType,
                JSON.stringify(this.showColumnTitleArray)
            );

            this.columns = showArray;
        },
        showPage() {
            var that = this;

            var searchParam = that.searchObject;
            var searchMeterType = global.searchMeterType();
            if (searchMeterType != undefined) {
                searchParam.meterType = searchMeterType;
            }
            if(searchParam.startDate){
                searchParam.endDate = new Date(global.dateFtt("yyyy-MM-dd", searchParam.startDate) + " 23:59:59");
            }
            that.data = [];
            that.$axios
                .post("/api/meterdetailed/getMeterDetailedList", searchParam)
                .then(function(res) {
                    console.log(res);

                    let currentArray = res.body;
                    for (let i = 0; i < currentArray.length; i++) {
                        let temp = currentArray[i];
                        temp["出厂日期"] = "\t" + global.dateFtt("yyyy-MM-dd", new Date(temp.meterBirth));
                        temp["NB模块IMEI"] = "\t" + temp.meterImei;
                        temp["NB卡IMSI"] = "\t" + temp.meterImsi;
                        temp["NB卡ICCID"] = "\t" + temp.meterIccid;
                        // temp["初始反向流量"] = "\t" + temp.meterFlowBackward + " L";
                        // temp["初始正向流量"] = "\t" + temp.meterFlowForward + " L";
                        temp["初始冷量"] = "\t" + temp.meterHot + " L";
                        temp["初始热量"] = "\t" + temp.meterCool + " L";
                        temp["初始流量"] = "\t" + temp.meterFlowForward + " L";

                        temp["初始正向流量"] =
                            temp.meterFlowForward == undefined
                                ? ""
                                : Math.round((parseFloat(temp.meterFlowForward) / 1000) * 100) / 100 + " m³";
                        temp["初始反向流量"] =
                            temp.meterFlowBackward == undefined
                                ? ""
                                : Math.round((parseFloat(temp.meterFlowBackward) / 1000) * 100) / 100 + " m³";
                        temp["meterIpport"] = temp["meterIpport"].replace(/[\x00-\x00]+/g,"");
                        currentArray[i] = temp;
                    }

                    that.data = currentArray;
                })
                .catch(function(error) {
                    console.log(error);
                });


                that.$axios
                .post("/api/meterdetailed/getMeterBirthList", searchParam)
                .then(function(res) {
                    that.dateArray = res.body;
                })
                .catch(function(error) {
                    console.log(error);
                });
                
        }
    },
    mounted() {
        // this.showPage();
        let that = this;
        window.addEventListener("resize", function() {
            that.tableHeight = (window.innerHeight - 186) * 0.65;
        });
        that.tableHeight = (window.innerHeight - 186) * 0.65;

        that.getMeterCaliberEnum();
        that.getUserList();
        // that.showPage();
        that.getMeterProtocolEnum();

        var cs = [];
        if (this.searchObject.meterType == "水表") {
            cs = [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 160,
                    resizable: true
                },
                // {
                //     title: "出厂日期",
                //     width: 160,
                //     resizable: true,
                //     key: "出厂日期"
                // },
                {
                    title: "表具类型",
                    resizable: true,
                    width: 100,
                    key: "meterType"
                },
                {
                    title: "口径",
                    resizable: true,
                    width: 100,
                    key: "meterCaliber"
                },
                {
                    title: "表具地址",
                    resizable: true,
                    width: 150,
                    key: "meterAddress"
                },
                {
                    title: "初始正向流量",
                    resizable: true,
                    width: 120,
                    key: "初始正向流量"
                },
                {
                    title: "初始反向流量",
                    resizable: true,
                    width: 120,
                    key: "初始反向流量"
                },
                {
                    title: "运营商",
                    resizable: true,
                    width: 100,
                    key: "meterOperator"
                },
                {
                    title: "NB模块IMEI",
                    resizable: true,
                    width: 150,
                    key: "NB模块IMEI"
                },
                {
                    title: "NB卡IMSI",
                    resizable: true,
                    width: 150,
                    key: "NB卡IMSI"
                },
                {
                    title: "NB卡ICCID",
                    resizable: true,
                    width: 180,
                    key: "NB卡ICCID"
                },
                {
                    title: "域名(IP)及端口",
                    resizable: true,
                    width: 170,
                    key: "meterIpport"
                },
                {
                    title: "采集模式",
                    resizable: true,
                    width: 120,
                    key: "meterCatchMode"
                },
                {
                    title: "采集间隔(分钟)",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval"
                },
                {
                    title: "定时采集时间1",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval1"
                },
                {
                    title: "定时采集时间2",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval2"
                },
                {
                    title: "定时采集时间3",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval3"
                },
                {
                    title: "定时采集时间4",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval4"
                },
                {
                    title: "表端协议类型",
                    resizable: true,
                    width: 120,
                    key: "meterProtocolType"
                },
                {
                    title: "电池电压",
                    resizable: true,
                    width: 120,
                    key: "meterVoltage"
                },
                {
                    title: "操作",
                    slot: "action",
                    width: 150,
                    align: "center"
                }
            ];
        }

        if (this.searchObject.meterType == "热量表") {
            cs = [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 160,
                    resizable: true
                },
                {
                    title: "出厂日期",
                    width: 160,
                    resizable: true,
                    key: "出厂日期"
                },
                {
                    title: "表具类型",
                    resizable: true,
                    width: 100,
                    key: "meterType"
                },
                {
                    title: "口径",
                    resizable: true,
                    width: 100,
                    key: "meterCaliber"
                },
                {
                    title: "表具地址",
                    resizable: true,
                    width: 150,
                    key: "meterAddress"
                },
                {
                    title: "初始冷量",
                    resizable: true,
                    width: 120,
                    key: "初始冷量"
                },
                {
                    title: "初始热量",
                    resizable: true,
                    width: 120,
                    key: "初始热量"
                },
                {
                    title: "初始流量",
                    resizable: true,
                    width: 120,
                    key: "初始流量"
                },
                {
                    title: "运营商",
                    resizable: true,
                    width: 100,
                    key: "meterOperator"
                },
                {
                    title: "NB模块IMEI",
                    resizable: true,
                    width: 150,
                    key: "NB模块IMEI"
                },
                {
                    title: "NB卡IMSI",
                    resizable: true,
                    width: 150,
                    key: "NB卡IMSI"
                },
                {
                    title: "NB卡ICCID",
                    resizable: true,
                    width: 180,
                    key: "NB卡ICCID"
                },
                {
                    title: "域名(IP)及端口",
                    resizable: true,
                    width: 170,
                    key: "meterIpport"
                },
                {
                    title: "采集模式",
                    resizable: true,
                    width: 120,
                    key: "meterCatchMode"
                },
                {
                    title: "采集间隔(分钟)",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval"
                },
                {
                    title: "定时采集时间1",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval1"
                },
                {
                    title: "定时采集时间2",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval2"
                },
                {
                    title: "定时采集时间3",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval3"
                },
                {
                    title: "定时采集时间4",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval4"
                },
                {
                    title: "表端协议类型",
                    resizable: true,
                    width: 120,
                    key: "meterProtocolType"
                },
                {
                    title: "电池电压",
                    resizable: true,
                    width: 120,
                    key: "meterVoltage"
                },
                {
                    title: "操作",
                    slot: "action",
                    width: 150,
                    align: "center"
                }
            ];
        }

        if (this.searchObject.meterType == "流量计") {
            cs = [
                {
                    title: "序号",
                    type: 'index',
                    width: 100,
                    align: 'center'
                },
                {
                    title: "客户名称",
                    key: "userName",
                    width: 160,
                    resizable: true
                },
                {
                    title: "出厂日期",
                    width: 160,
                    resizable: true,
                    key: "出厂日期"
                },
                {
                    title: "表具类型",
                    resizable: true,
                    width: 100,
                    key: "meterType"
                },
                {
                    title: "口径",
                    resizable: true,
                    width: 100,
                    key: "meterCaliber"
                },
                {
                    title: "表具地址",
                    resizable: true,
                    width: 150,
                    key: "meterAddress"
                },
                {
                    title: "初始正向流量",
                    resizable: true,
                    width: 120,
                    key: "初始正向流量"
                },
                {
                    title: "初始反向流量",
                    resizable: true,
                    width: 120,
                    key: "初始反向流量"
                },
                {
                    title: "运营商",
                    resizable: true,
                    width: 100,
                    key: "meterOperator"
                },
                {
                    title: "NB模块IMEI",
                    resizable: true,
                    width: 150,
                    key: "NB模块IMEI"
                },
                {
                    title: "NB卡IMSI",
                    resizable: true,
                    width: 150,
                    key: "NB卡IMSI"
                },
                {
                    title: "NB卡ICCID",
                    resizable: true,
                    width: 180,
                    key: "NB卡ICCID"
                },
                {
                    title: "域名(IP)及端口",
                    resizable: true,
                    width: 170,
                    key: "meterIpport"
                },
                {
                    title: "采集模式",
                    resizable: true,
                    width: 120,
                    key: "meterCatchMode"
                },
                {
                    title: "采集间隔(分钟)",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval"
                },
                {
                    title: "定时采集时间1",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval1"
                },
                {
                    title: "定时采集时间2",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval2"
                },
                {
                    title: "定时采集时间3",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval3"
                },
                {
                    title: "定时采集时间4",
                    resizable: true,
                    width: 120,
                    key: "meterCatchInterval4"
                },
                {
                    title: "表端协议类型",
                    resizable: true,
                    width: 120,
                    key: "meterProtocolType"
                },
                {
                    title: "电池电压",
                    resizable: true,
                    width: 120,
                    key: "meterVoltage"
                },
                {
                    title: "操作",
                    slot: "action",
                    width: 150,
                    align: "center"
                }
            ];
        }

        that.columns = cs;
        that.columnsbackup = cs;
        that.generateColumnTitleArray();
    }
};
</script>

<style scoped></style>
